import React from 'react';
import Reports from './Reports';
export const RaporlarAnalizler = () => {
  return <Reports data-id="element-1093" />;
};
export default RaporlarAnalizler;